// NOTE: This must be changed on the LLM-service at the same time.
export const SOURCING_EXTERNAL_INDUSTRIES = [
  'Defense & Space',
  'Computer Hardware',
  'Computer Software',
  'Computer Networking',
  'Internet',
  'Semiconductors',
  'Telecommunications',
  'Law Practice',
  'Legal Services',
  'Management Consulting',
  'Biotechnology',
  'Medical Practice',
  'Hospital & Health Care',
  'Pharmaceuticals',
  'Veterinary',
  'Medical Device',
  'Cosmetics',
  'Apparel & Fashion',
  'Sporting Goods',
  'Tobacco',
  'Supermarkets',
  'Food Production',
  'Consumer Electronics',
  'Consumer Goods',
  'Furniture',
  'Retail',
  'Entertainment',
  'Gambling & Casinos',
  'Leisure, Travel & Tourism',
  'Hospitality',
  'Restaurants',
  'Sports',
  'Food & Beverages',
  'Motion Pictures & Film',
  'Broadcast Media',
  'Museums & Institutions',
  'Fine Art',
  'Performing Arts',
  'Recreational Facilities & Services',
  'Banking',
  'Insurance',
  'Financial Services',
  'Real Estate',
  'Investment Banking',
  'Investment Management',
  'Accounting',
  'Construction',
  'Building Materials',
  'Architecture & Planning',
  'Civil Engineering',
  'Aviation & Aerospace',
  'Automotive',
  'Chemicals',
  'Machinery',
  'Mining & Metals',
  'Oil & Energy',
  'Shipbuilding',
  'Utilities',
  'Textiles',
  'Paper & Forest Products',
  'Railroad Manufacture',
  'Farming',
  'Ranching',
  'Dairy',
  'Fishery',
  'Primary/Secondary Education',
  'Higher Education',
  'Education Management',
  'Research',
  'Military',
  'Legislative Office',
  'Judiciary',
  'International Affairs',
  'Government Administration',
  'Executive Office',
  'Law Enforcement',
  'Public Safety',
  'Public Policy',
  'Marketing & Advertising',
  'Newspapers',
  'Publishing',
  'Printing',
  'Information Services',
  'Libraries',
  'Environmental Services',
  'Package/Freight Delivery',
  'Individual & Family Services',
  'Religious Institutions',
  'Civic & Social Organization',
  'Consumer Services',
  'Transportation/Trucking/Railroad',
  'Warehousing',
  'Airlines/Aviation',
  'Maritime',
  'Information Technology & Services',
  'Market Research',
  'Public Relations & Communications',
  'Design',
  'Non-profit Organization Management',
  'Fundraising',
  'Program Development',
  'Writing & Editing',
  'Staffing & Recruiting',
  'Professional Training & Coaching',
  'Venture Capital & Private Equity',
  'Political Organization',
  'Translation & Localization',
  'Computer Games',
  'Events Services',
  'Arts & Crafts',
  'Electrical & Electronic Manufacturing',
  'Online Media',
  'Nanotechnology',
  'Music',
  'Logistics & Supply Chain',
  'Plastics',
  'Computer & Network Security',
  'Wireless',
  'Alternative Dispute Resolution',
  'Security & Investigations',
  'Facilities Services',
  'Outsourcing/Offshoring',
  'Health, Wellness & Fitness',
  'Alternative Medicine',
  'Media Production',
  'Animation',
  'Commercial Real Estate',
  'Capital Markets',
  'Think Tanks',
  'Philanthropy',
  'E-learning',
  'Wholesale',
  'Import & Export',
  'Mechanical Or Industrial Engineering',
  'Photography',
  'Human Resources',
  'Business Supplies & Equipment',
  'Mental Health Care',
  'Graphic Design',
  'International Trade & Development',
  'Wine & Spirits',
  'Luxury Goods & Jewelry',
  'Renewables & Environment',
  'Glass, Ceramics & Concrete',
  'Packaging & Containers',
  'Industrial Automation',
  'Government Relations'
] as const;
